<div class="general-result">
    <div class="general-result__chart">
      <apx-chart
        [series]="chartOptions.series"
        [chart]="chartOptions.chart"
        [xaxis]="chartOptions.xaxis"
        [yaxis]="chartOptions.yaxis"
        [colors]="chartOptions.colors"
        [dataLabels]="chartOptions.dataLabels"
        [plotOptions]="chartOptions.plotOptions">
      </apx-chart>
    </div>
  
    <div class="general-result__description">
      <p [innerHTML]="levelDescription | breakLines">
      </p>
    </div>
  </div>
  